import { Component, Input, OnChanges } from '@angular/core';
import { ECharts, EChartsOption } from 'echarts';
import { VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { buildSpeedVoltageScatterOptions, getSpeedVoltageCorrelation, getSpeedVoltagePoints } from './speed-voltage-scatter.utils';

@Component({
  selector: 'app-voltage-speed-scatter',
  templateUrl: './speed-voltage-scatter.component.html',
  styleUrls: ['./speed-voltage-scatter.component.css']
})
export class VoltageSpeedScatterComponent implements OnChanges {
  @Input() samples: VoltageSpeedDashboardSample[] = [];

  options: EChartsOption = {};
  hasData = false;
  correlation: number | null = null;
  strongCorrelation = false;
  chart: ECharts | null = null;

  ngOnChanges(): void {
    const points = getSpeedVoltagePoints(this.samples);
    this.hasData = points.length > 0;
    this.correlation = getSpeedVoltageCorrelation(points);
    this.strongCorrelation = this.correlation != null && Math.abs(this.correlation) > 0.6;
    this.options = buildSpeedVoltageScatterOptions(points);
  }

  zoom(factor: number): void {
    if (!this.chart) return;
    const ranges = this.chart.getOption().dataZoom as { start: number; end: number }[];
    this.chart.dispatchAction({
      type: 'dataZoom',
      batch: ranges.slice(0, 2).map((range, dataZoomIndex) => {
        const center = (range.start + range.end) / 2;
        const span = Math.min(100, Math.max(1, (range.end - range.start) * factor));
        const start = Math.max(0, Math.min(100 - span, center - span / 2));
        return { dataZoomIndex, start, end: start + span };
      })
    });
  }

  resetZoom(): void {
    this.chart?.dispatchAction({ type: 'dataZoom', start: 0, end: 100 });
  }
}
